import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Log } from './log.model';
import { LogPopupService } from './log-popup.service';
import { LogService } from './log.service';

@Component({
    selector: 'dcs-log-delete-dialog',
    templateUrl: './log-delete-dialog.component.html'
})
export class LogDeleteDialogComponent {

    log: Log;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private logService: LogService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['log']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.logService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'logListModification',
                content: 'Deleted an log'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'dcs-log-delete-popup',
    template: ''
})
export class LogDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private logPopupService: LogPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.logPopupService
                .open(LogDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/log/log-delete-dialog.component.ts